import React, { useState } from "react";
import MLToleranceSection from "../machineLearningConfigs/MLToleranceSection";
import MLLearningPeriodSection from "../machineLearningConfigs/MLLearningPeriodSection";
import { ChevronDown } from 'lucide-react';

export default function MLConfigsSection() {

  const [collapsed, setCollapsed] = useState(true);

  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Machine Learning Configs</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <MLToleranceSection />
        <div className="oct_settings-divider">
          <MLLearningPeriodSection />
        </div>
      </div>
    </>
  );
}
